import { CreateBrandPartnerBudgetItemData } from "./create-brand-partner-budget-item-data";

export class CreateBrandPartnerBudgetsData {
  public budgets: CreateBrandPartnerBudgetItemData[];
  constructor(budgets: CreateBrandPartnerBudgetItemData[]) {
    this.budgets = budgets;
  }
}
